import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  booleanAttribute,
  Component,
  ElementRef,
  input,
  model,
  OnInit,
  output,
  viewChild,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { BaseInput, Icon } from "libs/client-libs/src/components/components";
import { debounceTime, distinctUntilChanged, fromEvent, skip } from "rxjs";

@Component({
  selector: "app-input-search",
  standalone: true,
  imports: [CommonModule, Icon, FormsModule],
  templateUrl: "./input-search.component.html",
  styleUrl: "./input-search.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: InputSearchComponent,
      multi: true,
    },
  ],
})
export class InputSearchComponent
  extends BaseInput<any>
  implements AfterViewInit, OnInit, ControlValueAccessor
{
  inputClick = output<void>();
  inputFocus = output<void>();
  inputBlur = output<void>();

  inputRef = viewChild<ElementRef<HTMLInputElement>>("inputRef");

  width = input<string>();
  round = input<string>();
  query = model<string>("");

  icon = input<boolean, string | boolean>(true, {
    transform: booleanAttribute,
  });

  async ngAfterViewInit() {
    this.value$.subscribe((value) => {
      if (value) {
        this.inputRef()!.nativeElement.value = value.toString()!;
      }
    });

    fromEvent(this.inputRef()!.nativeElement, "input")
      .pipe(skip(1), debounceTime(this.debounce()), distinctUntilChanged())
      .subscribe((ev: any) => {
        this.value.set(ev.target.value);
      });
  }

  search() {
    this.value.set(this.query());
  }

  handlePaste(event: ClipboardEvent) {
    const pastedText = event.clipboardData?.getData("text") || "";

    if (pastedText) {
      this.value.set(pastedText);
    }
  }
}
